export default "__VITE_ASSET__CjX1hEU1__"